<h2>upp-scrollable</h2>
<p class="demo-description">Message feed with configurable scroll direction via <code>upp-scrollable</code>.</p>

<div class="demo-controls">
    <span class="control-label">Direction:</span>
    <ion-button size="small" [fill]="direction === 'none' ? 'solid' : 'outline'" (click)="setDirection('none')">none</ion-button>
    <ion-button size="small" [fill]="direction === 'x' ? 'solid' : 'outline'" (click)="setDirection('x')">x</ion-button>
    <ion-button size="small" [fill]="direction === 'y' ? 'solid' : 'outline'" (click)="setDirection('y')">y</ion-button>
    <ion-button size="small" [fill]="direction === 'both' ? 'solid' : 'outline'" (click)="setDirection('both')">both</ion-button>
</div>

<div class="demo-section">
    <h3>Messages (scrollbar={{ direction }})</h3>
    <div class="feed-container">
        <upp-scrollable [scrollbar]="direction">
            <div [class]="direction === 'x' ? 'messages-row' : 'messages-column'">
                <div class="message-card" *ngFor="let msg of messages">
                    <div class="message-header">
                        <span class="message-sender">{{ msg.sender }}</span>
                        <span class="message-time">{{ msg.time }}</span>
                    </div>
                    <div class="message-text">{{ msg.text }}</div>
                </div>
            </div>
        </upp-scrollable>
    </div>
</div>
